module.exports = __webpack_public_path__ + "static/media/48234037_2308766715865173_8982457301063434240_o.6744fb9d.jpg";